// TODO It would be nice to find something to convert coffescript to JS

// swym-button-bar - See swymSnippet.liquid for Wishlist
// https://swym.freshdesk.com/support/solutions/articles/9000178251-implementing-a-custom-add-to-wishlist-button-on-the-product-pages
function positionWishlist(){
  if($('.swym-button-bar').length > 0){
    //$('.wishlist-button-container').append( $('.swym-button-bar') );
    $('.swym-button-bar').remove();
    clearInterval(wishlistReposition);
  }
}

$(document).ready(function(){

  // Move the Wishlist button
  window.wishlistReposition = setInterval(positionWishlist,100)

  // Apply standard attributes for tabs (default appearance)
  $('[data-responsive-accordion-tabs]').attr('role','tablist');
  $('[data-responsive-accordion-tabs] li.tabs-title').attr('role','presentation');
  $('[data-responsive-accordion-tabs] li.tabs-title a').attr('role','tab');
  // TODO It would be nice to implement aria-expanded=true|false

  $('body').on('tabSelected', '[data-responsive-accordion-tabs]', function(e, panel){

    //  Update the tab headers display
    var state = 'tab';
    if($('[data-responsive-accordion-tabs]').hasClass('accordion')){
      state = 'accordion';
    }
    displayTabAccordion(state, panel);
  });

  $('body').on('change', 'select', function(e){
    $(this).trigger('optionSelected');
  });

  $('body').on('accordionItemClicked', '[data-responsive-accordion-tabs] > li', function(e){

    // Get the panel ID
    if( $(this).hasClass('tabs-title') ){
      var panel = $(this).find('> a').attr('aria-controls');
    }else if( $(this).hasClass('accordion-item') ){
      var panel = $(this).find('> a').attr('aria-controls');
    }

    // Is it an accordian and already open (e.g. needs to close)
    if( $('[data-responsive-accordion-tabs]').hasClass('accordion') ){
      if( $('li.accordion-item div.tabs-panel.is-active').length > 0){
        var activePanel = $('li.accordion-item div.tabs-panel.is-active').attr('id');
        if( panel == activePanel ){
          e.preventDefault();
          displayTabAccordion('closedAccordian');
          return;
        }
      }
    }
    $(this).trigger("tabSelected", panel);
  });

  $('body').on('click', '[data-responsive-accordion-tabs] > li > a', function(e){

    if(!$(this).attr('role')){
      return true;
    }
    // Stop using the anchors on the desktop
    e.preventDefault();

    $(this).trigger('accordionItemClicked');
  });

  /**
   * Ensure the description panel is open
   */
  $('[data-readmore]').on('click', function(){
    var state = $('[data-responsive-accordion-tabs]').attr('data-state');
    displayTabAccordion(state,'description');
  });
  /**
   *  This refers to the copy links that allow naviagation to the different panels
   */
  $('[data-tab-link]').on('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    var state = $('[data-responsive-accordion-tabs]').attr('data-state');
    var panel = $(this).attr('data-tab-link');
    displayTabAccordion(state, panel, true);
  });

  function displayAsMobile(){
    if( $('[data-responsive-accordion-tabs]').hasClass('accordion') ){
      return;
    }
    var panel = $('[data-responsive-accordion-tabs]').attr('data-panel');
    if(panel == undefined){
      panel = 'customer-reviews'; // TODO Might be a problem if no customer reviews exist
    };
    displayTabAccordion('accordion', panel, false);
  }

  function displayAsDesktop(){
    var panel = $('[data-responsive-accordion-tabs]').attr('data-panel');
    if( $('[data-responsive-accordion-tabs]').hasClass('tabs') && panel != undefined ){
      return;
    }

    // If no tabs are open then open the first panel
    if(!anyTabsActive()){
      $('[data-responsive-accordion-tabs]').trigger("tabSelected",'description');
    }
    if(panel == undefined){
      panel = 'description';
    }
    displayTabAccordion('tab', panel);
  }

  window.displayTabAccordion = function(state, panel, scroll = true){
    if(state == 'closedAccordian' && $('[data-responsive-accordion-tabs]').attr('data-state') == state){
      return;
    }
    if( $('[data-responsive-accordion-tabs]').attr('data-state') == state && $('[data-responsive-accordion-tabs]').attr('data-panel') == panel){
      return;
    }

    // If the currently open panel is the customer reviews
    // and changing to tabbed content then revert to description
    if((state == 'tab') && (panel == 'customer-reviews')){
      panel = 'description';
    }
    $('[data-responsive-accordion-tabs]').attr('data-state', state);
    if(panel != undefined){
      $('[data-responsive-accordion-tabs]').attr('data-panel', panel);
    }
    //console.log(`2. displayTabAccordion state: ${state} panel: ${panel}`);

    switch(state){
      case 'closedAccordian':
        // Move the tab content into the list items
        $.each($('[data-responsive-accordion-tabs] > li > a'), function(index, element) {
          $('#'+$(element).attr('aria-controls')).insertAfter(element);
        });

        // Show the customer review
        $('[data-responsive-accordion-tabs] [data-tab-id="customer-reviews"]').removeClass('hidden')

        // Hide the separate customer reviews header
        $('#tabs-overflow > h2').hide();

        $('[data-responsive-accordion-tabs] > li.rated-item').show();
        $('[data-responsive-accordion-tabs]').removeClass('tabs');
        $('[data-responsive-accordion-tabs]').addClass('accordion');

        //  Update the tab headers display
        $('[data-responsive-accordion-tabs] li.tabs-title').removeClass('is-active');
        $('[data-responsive-accordion-tabs] li.accordion-item').removeClass('is-active');

        // Reclass the list items as accordian-item from tabs-title
        $('[data-responsive-accordion-tabs] > li.tabs-title').removeClass('tabs-title');
        $('[data-responsive-accordion-tabs] > li').addClass('accordion-item');
        $('[data-responsive-accordion-tabs] > li.accordion-item > a').addClass('accordion-title');

        // Hide all the content panels
        $('.tabs-panel').removeClass('is-active');

        if(state == 'closedAccordian' && panel == undefined){
          $('#customer-reviews').hide();
        }

        break;
      case 'tab':

        // Move the content accordion content to the tabs section
        $.each( $('[data-responsive-accordion-tabs] > li > div'), function(index, element) {
          // Move the elements into the tab content
          $('[data-tabs-content]').append($(element));
        });

        // Hide the customer review
        $('[data-responsive-accordion-tabs] [data-tab-id="customer-reviews"]').addClass('hidden')

        $('[data-responsive-accordion-tabs]').removeClass('accordion');
        $('[data-responsive-accordion-tabs]').addClass('tabs');
        $('[data-responsive-accordion-tabs] > li.accordion-item > a').removeClass('accordion-title');
        $('[data-responsive-accordion-tabs] > li.accordion-item').removeClass('accordion-item');
        $('[data-responsive-accordion-tabs] > li').addClass('tabs-title');
        $('[data-responsive-accordion-tabs] > li.rated-item').hide(); // TODO Might move this to become the header
        $('[data-tab-conent="customer-reviews"]').show();

        //  Update the tab headers display
        $('[data-responsive-accordion-tabs] li.tabs-title').removeClass('is-active');
        $('[data-responsive-accordion-tabs] li.accordion-item').removeClass('is-active');
        $('[data-responsive-accordion-tabs] li > a[aria-controls='+panel+']').parent().addClass('is-active');

        // Hide all the content panels
        //$('.tabs-panel').removeClass('is-active');
        $('.tabs-panel').addClass('hidden');

        // Open the selected panel and customer reviews
        //$('.tabs-content #'+panel).addClass('is-active');
        $('.tabs-content #'+panel).removeClass('hidden');

        // Show the separate customer reviews header
        $('#tabs-overflow > h2').show();

        // Open the customer reviews panel
        $('[data-tab-content="customer-reviews"]').show();

        // Move the tab content so it is under tabs-overflow
        $('#tabs-overflow').append($('[data-tab-content="customer-reviews"]'));

        break;
      case 'accordion':

        // Move the tab content into the list items
        $.each($('[data-responsive-accordion-tabs] > li > a'), function(index, element) {
          $('#'+$(element).attr('aria-controls')).insertAfter(element);
        });

        // Show the customer review
        $('[data-responsive-accordion-tabs] [data-tab-id="customer-reviews"]').removeClass('hidden');

        // Show the selected content
        $('.tabs-panel').addClass('hidden');
        $(`#${panel}`).removeClass('hidden');

        // Hide the separate customer reviews header
        $('#tabs-overflow > h2').hide();

        $('[data-responsive-accordion-tabs] > li.rated-item').show();
        $('[data-responsive-accordion-tabs]').removeClass('tabs');
        $('[data-responsive-accordion-tabs]').addClass('accordion');

        //  Update the tab headers display
        $('[data-responsive-accordion-tabs] li.tabs-title').removeClass('is-active');
        $('[data-responsive-accordion-tabs] li.accordion-item').removeClass('is-active');
        $('[data-responsive-accordion-tabs] li > a[aria-controls='+panel+']').parent().addClass('is-active');

        // Reclass the list items as accordian-item from tabs-title
        $('[data-responsive-accordion-tabs] > li.tabs-title').removeClass('tabs-title');
        $('[data-responsive-accordion-tabs] > li').addClass('accordion-item');
        $('[data-responsive-accordion-tabs] > li.accordion-item > a').addClass('accordion-title');

        // Hide all the content panels
        $('.tabs-panel').removeClass('is-active');
        //$('.tabs-panel').addClass('hidden');
        $('[data-responsive-accordion-tabs] #'+panel).addClass('is-active');
        //$('[data-responsive-accordion-tabs] #'+panel).removeClass('hidden');

        if(panel != 'customer-reviews'){
          $('#customer-reviews').hide();
        }else{
          $('#customer-reviews').show();
        }

        if(scroll){
          let top = $("[href='#"+panel+"']").offset().top - stickyHeaderHeight();
          window.scroll({
            top: top,
            behavior: "smooth"
          });
        }

        break;
      default:
        console.error('Unknow state: '+state);
        break;
    }
  }

  function stickyHeaderHeight(){
    if( $('#mobileNavBar:visible').length != 0 ){
      return parseInt($('#mobileNavBar:visible').css('height'));
    }
    return 0;
  }

  function anyTabsActive(){
    if($('[data-responsive-accordion-tabs] li.accordion-item.is-active').length > 0){
      return true;
    }
    return false;
  }

  $(window).resize(function(){
    if($(window).width() < 1280){
      //if($(window).width() <= 1000){
      displayAsMobile();
    }else{
      displayAsDesktop()
    }
  });
  $(window).trigger('resize');

  $('body').on('click', '[data-sign-required]', function(e){
    e.preventDefault();
    $('#addToWishListModal').modal();
  });

  $('body.template-product').on('click', '.variant-colour-palette li a', function(e){
    e.preventDefault();
    if( $(this).hasClass('active') ){
      return;
    }
    $(this).trigger('swatchSelected', $(this).attr('data-colour'));
  });

  $('body.template-product').on('swatchSelected','[data-colour-picker] li', function(e, colour){
    e.preventDefault();
    if( $(this).hasClass('disabled') ){
      return true;
    }
    $(this).trigger('colourSelected', colour);
  });

  $('body.template-product').on('colourSelected','[data-colour-picker]', function(e, colour){
    let option = 'option'+$(this).attr('data-option-position');
    window.pageState[option] = colour;

    let pageStateChangeEvent = new CustomEvent('pageStateChange', {
      detail: Object.assign({}, window.pageState)
    });
    document.querySelector('body').dispatchEvent(pageStateChangeEvent);
  });


  let updatePaletteHandler = function(e){

    // TODO Simplify this
    if( $('[data-colour-picker][data-option-position=1]').length > 0 ){
      var colour = e.detail.option1;
      var colourPicker = $('[data-colour-picker][data-option-position=1]');
      colourPicker.find('a').removeClass('active');
      colourPicker.find("[data-colour='"+colour+"']").addClass('active');
      colourPicker.find('select').val(colour);
    }
    if( $('[data-colour-picker][data-option-position=2]').length > 0 ){
      var colour = e.detail.option2;
      var colourPicker = $('[data-colour-picker][data-option-position=2]');
      colourPicker.find('a').removeClass('active');
      colourPicker.find("[data-colour='"+colour+"']").addClass('active');
      colourPicker.find('select').val(colour);
    }
    if( $('[data-colour-picker][data-option-position=3]').length > 0 ){
      var colour = e.detail.option2;
      var colourPicker = $('[data-colour-picker][data-option-position=3]');
      colourPicker.find('a').removeClass('active');
      colourPicker.find("[data-colour='"+colour+"']").addClass('active');
      colourPicker.find('select').val(colour);
    }
  }

  document.querySelector('body').addEventListener('pageStateChange', updatePaletteHandler);

  let updateAvailabilityFilterHandler  = function(e){

    // Change the highlighted filter
    if( e.detail.availabilityFilter ){
      $('.colour-tabs > li').removeClass('active');
      $('.colour-tabs > li[data-colour-availability-button='+e.detail.availabilityFilter+']').addClass('active');
      // $(this).addClass('active');
    }

    if( e.detail.availabilityFilter ){

      var enabledColours = e.detail.availableColours;
      $('.colour-picker-tabs-content .content ul.variant-colour-palette > li').each( function(index) {
        var exists = false;
        for(var index in enabledColours){
          if($(this).hasClass(enabledColours[index])){
            exists = true;
            break;
          }
        }
        if(!exists){ $(this).addClass('disabled') };
      });

      $('[data-colour-availability]').show();

      if(enabledColours.length > 0){
        $('.product-details .options .input-group').removeClass('hidden');
        $('.product-details .options label').removeClass('hidden');

        document.querySelectorAll('[data-colour-availability-message]').forEach(
          function(element) {
            element.innerHTML = e.detail.availabilityMessage;
            element.classList.remove('no-colours-available');
          }
        );

      }else{
        $('.product-details ul.variant-colour-palette li a').removeClass('active');
        $('.product-details .options .input-group').addClass('hidden');
        $('.product-details .options label').addClass('hidden');

        $('[data-availability-container-general]').text('');
      }

    }
  }

  document.querySelector('body').addEventListener('pageStateChange', updateAvailabilityFilterHandler);

});

$(document).ready(function(){
  $('body').on( 'adjustQuantity', '[data-quantity-controls]', function(event, adjustment){
    var value = parseInt($(this).find('[data-line-item-quantity]').val());
    var newValue = value + adjustment;
    if(newValue < 1)return;
    $(this).find('[data-line-item-quantity]').val(value + adjustment);
  });
  $('body').on('click', '[data-quantity-controls] .js--add', function(event){
    $(this).trigger('adjustQuantity', 1);
  });
  $('body').on('click', '[data-quantity-controls] .js--minus', function(event){
    $(this).trigger('adjustQuantity', -1);
  });
});
$(document).ready(function(){

  window.displayAsVariant = function(variantID){
    $('[data-variant-availability]').hide();
    $('[data-variant-info]').hide();
    $('[data-variant-availability="'+variantID.toString()+'"]').show();
    $('[data-variant-info="'+variantID.toString()+'"]').show();

    $('#addToCartForm-product-template input[name="id"]').val(variantID);

    // Append the variant ID to the URL
    window.loaction = window.location.pathname+'?variant='+variantID;

    var handle = $('[data-product-handle]').attr('data-product-handle');

    $('.product-photo-container [data-product-badge]').hide(); //HIDE Product badge once variant is selected

    loadVariantSpecificContent(handle, variantID);
  }

  window.unloadSelectedVariantContent = function(handle){
    var url = "/products/"+handle+"?view=add_to_cart";
    $.ajax({
      url: url
    }).done(function( data ) {
      $('[data-selected-variant-content]').html(data);
    });
  }

  // De-select the currently selected variant
  window.deselectVariant = function(){
    window.pageState['selectedVariant'] = null;
    let pageStateChangeEvent = new CustomEvent('pageStateChange', {
      detail: Object.assign({}, window.pageState)
    });
    document.querySelector('body').dispatchEvent(pageStateChangeEvent);
  }

  let changeMainImageHandler = function(e) {
    let variantImageId = window.variantImages[e.detail.selectedVariant];
    if(variantImageId){
      $('.product-photos').trigger('changeMainImage', variantImageId );
    }
  }

  document.querySelector('body').addEventListener('pageStateChange', changeMainImageHandler);

  // This should be triggered when the customer changes the variant rather than
  // the default variant is automatically selected.
  window.changeSelectedVariant = function(variantID){

    let event = new CustomEvent("variantSelected", {
      detail: {
        variantId : variantID
      }
    });
    document.querySelector('body').dispatchEvent(event);

    window.pageState['selectedVariant'] = variantID
    window.pageState['landing'] = false

    // Show/Hide variant badges as needed
    const badgeElements = document.querySelectorAll('[data-variant-badge-container]');
    badgeElements.forEach(element => {
      element.classList.add('hidden');
    });
    const selectedVariantElement = document.querySelector('[data-variant-badge-container="'+variantID+'"]');
    if(selectedVariantElement) {
      selectedVariantElement.classList.remove('hidden');
    }

    // Update the options to reflect the selected variant
    if(variantID){
      options = variantOptionValues[variantID]
      window.pageState['option1'] = options['option1']
      window.pageState['option2'] = options['option2']
      window.pageState['option3'] = options['option3']
    }

    let pageStateChangeEvent = new CustomEvent('pageStateChange', {
      detail: Object.assign({}, window.pageState)
    });
    document.querySelector('body').dispatchEvent(pageStateChangeEvent);
  }

  let changeVariantHandler = function(e){
    var selectedVariantId = e.detail.selectedVariant;
    if(selectedVariantId){
      displayAsVariant(selectedVariantId);
    }
  }
  document.querySelector('body').addEventListener('pageStateChange', changeVariantHandler);


  window.renderAsCombinationUnavailable = function(){
    window.pageState['selectedVariant'] = null;
    var handle = $('[data-product-handle]').attr('data-product-handle');
    loadCombinationUnavailableContent(handle);
  }

  // Add variant options
  if( $('[data-variant-options]').length > 0){

    $('[data-variant-options]').on('optionsChange', function(){
      var option1 = $(this).find('[data-index="option1"]').length > 0 ? $(this).find('[data-index="option1"] option:selected').attr('value') : null;
      var option2 = $(this).find('[data-index="option2"]').length > 0 ? $(this).find('[data-index="option2"] option:selected').attr('value') : null;
      var option3 = $(this).find('[data-index="option3"]').length > 0 ? $(this).find('[data-index="option3"] option:selected').attr('value') : null;

      // Get the total number of options
      var numberOfOptions = 0;
      if($(this).find('[data-index="option1"]').length > 0) numberOfOptions += 1;
      if($(this).find('[data-index="option2"]').length > 0) numberOfOptions += 1;
      if($(this).find('[data-index="option3"]').length > 0) numberOfOptions += 1;

      switch(numberOfOptions){
        case 0:
          return;
          break;
        case 1:
          var selected = [option1,'',''];
          if(option1 == null)return;
          break;
        case 2:
          var selected = [option1,option2,''];
          if(option1 == null)return;
          if(option2 == null)return;
          break;
        case 3:
          var selected = [option1, option2, option3];
          if(option1 == null)return;
          if(option2 == null)return;
          if(option3 == null)return;
          break;
      }
      var selectedPattern = selected.join('|');

      if(variantOptions[selectedPattern]){
        var selectedVariantID = variantOptions[selectedPattern];
        changeSelectedVariant(selectedVariantID);
      }else{
        console.warn('[www.worm.co.uk] VariantSelection: Could not match variant');
        renderAsCombinationUnavailable();
      }
    });

    $('[data-variant-options] select').on('change',function(){
      $(this).trigger('optionsChange');
    });
  };

  $('[data-variant-select]').on('change', function(e){
    var value = $(this).find('option:selected').val();
    changeSelectedVariant(value);
  });

  // Update the select handler to reflect selected option
  let changeSelectHandler = function(e){
    $.each( $('.custom-select'), function(index, element){
      if(window.pageState[$(element).attr('data-index')]){
        var value = window.pageState[$(element).attr('data-index')];
        if($(element).val() != value){
          $(element).val(value);
        }
      }
    });
  }
  document.querySelector('body').addEventListener('pageStateChange', changeSelectHandler);

  // Change page url
  const urlUpdateHandler = function(e) {
    const selectedVariant = e.detail.selectedVariant;
    let currentUrl = new URL(window.location);
    if (selectedVariant) {
        // Add or update the variant parameter
        currentUrl.searchParams.set('variant', selectedVariant);
    } else {
        // Remove the variant parameter if it's undefined or null
        currentUrl.searchParams.delete('variant');
    }
    // Update the browser URL without reloading the page
    history.replaceState(null, '', currentUrl.toString());
  }
  document.querySelector('body').addEventListener('pageStateChange', urlUpdateHandler);

  // // For variant dropdown selection
  // $('[data-variant-select]').trigger('change');

  // // For selection by option
  // if($('[data-variant-options]').length > 0){
  //   window.displayAsVariant($('[data-variant-options]').attr('data-variant-options'));
  // }
});
$(document).ready(function(){

  if($('.product-photos').length > 0){

    $('.product-photos').on('changeImage', function(e, imageSrcset){
      $(this).find('.product-photo-container img').attr('srcset', imageSrcset);
    });

    $('.product-photos').on('changeMainImage', function(e, imageId){
      console.log(`CHANGING changeMainImage: '${imageId}'`)
      //$(this).find('.lazyload__image-wrapper').addClass('hide');
      //$(this).find('#productPhotoWrapper--'+imageId).removeClass('hide');

      //input[name$='\[address_line_2\]']"

      // $('.product-photos').find('[data-image-id]').addClass('hidden');
      // $('.product-photos').find(`[data-image-id='${imageId}']`).removeClass('hidden');

      //$('.product-photos .product-photo-container').find('[data-image-id]').addClass('hidden')

      $(this).find('.product-photo-container [data-image-id]').addClass('hidden');
      $(this).find(`.product-photo-container [data-image-id='${imageId}']`).removeClass('hidden');      
    });

    $('.product-photos').on('click', '.product-photo-container [data-image-id]', function(e){
      e.preventDefault();
      var imageId = $(this).attr('data-image-id');
      $('#product-image-modal-'+imageId).modal({
        fadeDuration: 10
      });
    });

    if($('.product-photos .product-photo-thumbs').length > 0){
      $('.product-photos .product-photo-thumbs a').on('click', function(e){
        e.preventDefault();
        $(this).trigger('changeMainImage', $(this).attr('data-image-id') );
      });
    }

    
  }
});
$(document).ready(function(){

  $('[data-variant-options]').on('colourChange', function(element, colour, optionId){
    var index = optionId-1;
    $(this).find('#ProductSelect-'+index).val(colour);
    $(this).find('#ProductSelect-'+index).change();
  });

  $('[data-variant-options] .variant-colour-palette').on('colourSelected',function(element, colour){
    var index = $(this).attr('data-index');
    $(this).trigger('colourChange', [colour, index]);
  });

});
//alignMainMenu = () => {
alignMainMenu = function(){

  //console.log("alignMainMenu----> 20:37");
  //document.querySelectorAll("[data-menu-parent-id]").forEach( (rolloverElement) => { 
  document.querySelectorAll("[data-mega-menu]").forEach( (element) => { 

    // Is the menu wider than nav    
    const mainNavWidth = document.getElementById('navBar').offsetWidth; //document.getElementById('navBar').offsetWidth
    const navBarRect = document.getElementById('navBar').getBoundingClientRect();
    const navBarXPos =  navBarRect.left;  

    element.classList.remove('invisible');
    const menuWidth = element.offsetWidth;

    //var rect = rolloverElement.getBoundingClientRect();
    var rect = element.getBoundingClientRect();
    var xPosition = Math.round(rect.left);

    // Left hand corner position
    var relativeXPos = xPosition - navBarXPos;
    var relativeEndPoint = relativeXPos + menuWidth;

    //console.log(`menuWidth: ${menuWidth} mainNavWidth: ${mainNavWidth}`)
    if(menuWidth >= mainNavWidth){      
      var xOffet =  navBarXPos - element.getBoundingClientRect().left;
      xOffet = Math.round(xOffet);    
      console.log(navBarXPos);
      element.style.left = xOffet+'px';
    } else if(relativeEndPoint > mainNavWidth){
      // Handle the case where the menu will run off the screen
      var xOffet = mainNavWidth - relativeEndPoint;
      xOffet = Math.round(xOffet);
      element.style.left = xOffet+'px';      
    }

    // Enable the rollover hover effect
    element.classList.add('active')    
  });  
};

$(document).ready( function(){  
  window.setTimeout(alignMainMenu, 100);
});

// var menuResizeTimeout;
// function onMenuResize() {
//   clearTimeout(menuResizeTimeout);
//   menuResizeTimeout = setTimeout(alignMainMenu, 200); // 200 milliseconds delay
// }
// window.addEventListener('resize', onMenuResize);


$(document).ready(function () {

  // NOTE: This prevents the overlap from appearing from CloudSearch
  $('.search-bar input').on('click', function (e) {
    e.preventDefault();
  });

  $('#mobileNavBar .search-container a.search-icon').on('click', function (e) {
    e.preventDefault();

    if ($('#mobile-sub-header').hasClass('active') && !$('nav#mobile-menu').hasClass('active')) {
      $('#mobile-sub-header').removeClass('active menu');
    } else {
      $("html, body").animate({ scrollTop: 0 }, "medium");
      $("#small-searchbox input.searchinput").focus();
      $('#mobile-sub-header').addClass('active').removeClass('menu');
      $('nav#mobile-menu').removeClass('active');
      $('#mobile-sub-header input#query').focus().trigger('focus').trigger('click');
    }
  });

  // Select the parent element of the .cloud-search-mobile element(s)
  const parentElement = document.querySelector('body'); // Adjust this selector as needed

  // Create a MutationObserver instance
  const observer = new MutationObserver(function (mutationsList) {
    for (const mutation of mutationsList) {
      // Check if nodes have been removed
      if (mutation.type === 'childList') {
        mutation.removedNodes.forEach(function (node) {
          // Check if the removed node has the class 'cloud-search-mobile'
          if (node.classList && node.classList.contains('cloud-search-mobile')) {
            // Add your custom logic here, e.g., cleanup or UI updates
            handleSearchCancel();
          }
        });
      }
    }
  });

  // Configure the observer to listen for child list changes
  const config = { childList: true, subtree: true };

  // Start observing the parent element
  observer.observe(parentElement, config);
});

// Function to handle the cancel button click
function handleSearchCancel() {
  $('#mobileNavBar input').addClass('hidden');
  $('#mobile-sub-header').removeClass('active menu');
}
$(document).ready(function(){
  if( $('.main-brand-images').length > 0){
    // $('.show-image-zoom').on('click', function(){
    //   $(this).modal({
    //     fadeDuration: 10
    //   })
    // });

    // Open modal in AJAX callback

    // $('.show-image-zoom').click(function(event) {
    //   event.preventDefault();
    //   this.blur(); // Manually remove focus from clicked link.
    //   $.get(this.href, function(html) {
    //     $(html).appendTo('body').modal();
    //   });
    // });

    $('.show-image-zoom').each(function(index,element){
      var href = $(element).attr('href');
      var modalId = 'ex'+index;
      //$(element).removeAttr('href');

      //$(html).appendTo('body')
      $("<div id='"+modalId+"' class='modal'><img src='"+href+"'</div>").appendTo('body');
      
      $(element).attr('href','#'+modalId);
      //$(element).attr('id',id);
      $(element).attr('rel','modal:open');      
      // $(element).on('click', function(event){
      //   event.preventDefault();
      //   $(this).modal();
      //   //alert('CLICK');
      // });
    });

    // <div id="ex1" class="modal">
    //   <img src='https://ms-tw.s3.amazonaws.com/brand_image/719/full_3550AL_P3550ST_W3550T_P091COB_5780TAL_5071T_5454RODGT_5454YSN96_5725AL.jpg' />
    // </div>
    // <a href="#ex1" rel="modal:open">Open Modal</a>

  }
});
(function() {
  jQuery(function() {
    return $(document).ready(function() {
      var stickyHeaderBottom;
      stickyHeaderBottom = $('#mobileNavBar').offset().top + $('#mobileNavBar').outerHeight();

      $('.site-content-column').css('padding-top', $('#mobileNavBar').outerHeight());
      $(window).on("resize", function() {
        if ($('#mobileNavBar').is(':visible')) {
          return $('.site-content-column').css('padding-top', $('#mobileNavBar').outerHeight());
        } else {
          return $('.site-content-column').css('padding-top', 0);
        }
      });

      $('#toggle-mobile-menu').on('click', function(e) {

        e.preventDefault();
        if($('nav#mobile-menu').hasClass('active')) {
          $('nav#mobile-menu').removeClass('active');
          $('#mobile-sub-header').addClass('hidden');
          return $('#mobile-sub-header').removeClass('menu');
        } else {
          $("html, body").animate({
            scrollTop: 0
          }, "medium");
          $('nav#mobile-menu').addClass('active');
          $('#mobile-sub-header').removeClass('hidden');
          return $('#mobile-sub-header').addClass('menu');
        }
      });

      $('#toggle-mobile-search').on('click', function(e) {
        e.preventDefault();
        if ($('#mobile-sub-header').hasClass('active') && !$('nav#mobile-menu').hasClass('active') && $(window).scrollTop() <= stickyHeaderBottom) {
          $('#mobile-sub-header').removeClass('active');
          return $('#mobile-sub-header').removeClass('menu');
        } else {
          $("html, body").animate({
            scrollTop: 0
          }, "medium");
          $("#small-searchbox input.searchinput").focus();
          $('#mobile-sub-header').addClass('active');
          $('#mobile-sub-header').removeClass('menu');
          return $('nav#mobile-menu').removeClass('active');
        }
      });

      return $('.accordion-navigation a.goto-link').on('click', function(e) {
        if ($(this).hasClass('goto-link')) {
          e.preventDefault();
          return window.location.href = $(this).attr('href');
        }
      });
    });
  });

}).call(this);


window.checkCustomisation = function(){
  var variantId = $('[data-customisation-selected-variant-id]').attr('data-customisation-selected-variant-id');
  var source = $('#customisation-template-'+variantId).html();
  var template = Handlebars.compile(source);
  $("[data-snippet-name='variant-customisation']").html(template());
}


//accordion primary
$(document).ready(function(){

  // // Clicking the top level product opens the first element
  //$('dl.accordion.primary > dd.accordion-navigation.tier-1').on('menuClick', function(event){
  $('dl.accordion.primary > dd.accordion-navigation.tier-1').on('click', function(event){    
    if($(this).hasClass('active')){      
      $('dl.accordion.primary *').removeClass('active');
      $(this).find('.content').removeClass('active');
    }else{
      $('dl.accordion.primary *').removeClass('active');
      $(this).addClass('active');
      $(this).find('> .content:first').addClass('active');
      $(this).find('> .content:first dl.accordion1.primary').addClass('active');
      //$(this).find('> .content:first dl.accordion1.primary .content:first').addClass('active');
      //$(this).find('> .content:first dl.accordion1.primary > dd.tier-2').addClass('active');

      //$('.menu-christmas-shop > .content:first dl.accordion1.primary')
      //$('.menu-christmas-shop > .content:first dl.accordion1.primary .content:first').addClass('active')
    }
  });

  // Handle click child menu items
  $('dl.accordion > dd.accordion-navigation dd.accordion-navigation').on('click', function(event){
    event.stopPropagation();
    if($(this).hasClass('active')){
      $(this).removeClass('active');
      $(this).find('.content').removeClass('active');
    }else{
      $(this).addClass('active');
      $(this).find('> .content').addClass('active');
    }
  });

  window.scrollToMenu = function(element) {
    let top = $(element).offset().top - stickyHeaderHeight();
    window.scroll({ top: top, behavior: "smooth"});
  }  

  $('a.expandable').on('click', function(e){
    let top = $(this).offset().top - stickyHeaderHeight();
    setTimeout(function(element) { window.scrollToMenu(element)}, 60, $(this));
  });

  function stickyHeaderHeight(){
    if( $('#mobileNavBar:visible').length != 0 ){
      return parseInt($('#mobileNavBar:visible').css('height'));
    }
    return 0;
  }  

});


// Javascript for the collection.modular.liquid page
// TODO Need to have a page specific modular
// data-modular-collection

$(document).ready(function(){

  // data-accordion-container-id
  //$('.collection-modular-template .accordion .title[data-accordion-id]').on('click', function(){
  $('.collection-modular-template .accordion [data-accordion-title]').on('click', function(){
    var close = false;
    if($(this).hasClass('active')){
      close = true;
    }

    var panels = [];
    if($("[data-accordion-id='modules']").hasClass('active') && $(this).attr('data-accordion-id') != 'modules'){
      panels.push('modules');
    }

    if(close){
    }else{
      panels.push($(this).attr('data-accordion-id'));
    }

    //updateAccordian('main', panels);
    //close ? updateAccordian(null) : updateAccordian($(this).attr('data-accordion-id'));
    $(this).trigger('accordianUpdate', [panels]);
  });

  $('.collection-modular-template').on('accordianUpdate', '[data-accordion-container-id]', function(event, panels){
    event.stopPropagation();
    updateAccordian( $(this).attr('data-accordion-container-id') , panels);
  });

  function updateAccordian(id, panels){    
    // https://stackoverflow.com/questions/16642160/javascript-function-accepts-both-arrays-and-strings-as-parameter
    if (typeof panels === 'string') panels = [panels];
    $("[data-accordion-container-id='"+id+"'] [data-accordion-id]").removeClass('active');
    $("[data-accordion-container-id='"+id+"'] [data-accordion-id].content").addClass('hidden');
    $("[data-accordion-container-id='"+id+"'] [data-accordion-id] .right-arrow").removeClass('hidden');
    $("[data-accordion-container-id='"+id+"'] [data-accordion-id] .down-arrow").addClass('hidden');

    $(panels).each(function(index, panel){
      $("[data-accordion-container-id='"+id+"'] [data-accordion-id='"+panel+"']").addClass('active');
      $("[data-accordion-container-id='"+id+"'] [data-accordion-id='"+panel+"'].content").removeClass('hidden');
      $("[data-accordion-container-id='"+id+"'] [data-accordion-id='"+panel+"'] .right-arrow").addClass('hidden');
      $("[data-accordion-container-id='"+id+"'] [data-accordion-id='"+panel+"'] .down-arrow").removeClass('hidden');      
    });
  }

  window.scrollTo = function(panel){    
    var re = new RegExp('#'+panel);
    if(!window.location.href.match(re)){
      var href = window.location.href;
      if(href.match(/#.*/)){
        var anchor = href.match(/#.*/)[0];
        href = href.replace(anchor,'');
      }
      window.location = href+'#'+panel;
    }
    window.location = window.location.href; 
  }

  $('[data-accordion-open]').on('click', function(){
    var panels = [$(this).attr('data-accordion-open')];
    if($("[data-accordion-id='modules']").hasClass('active')){
      panels.push('modules');
    }

    updateAccordian('main',panels);
    scrollTo($(this).attr('data-accordion-open'));
  });

  updateAccordian('main', 'modules');

  window.clearAllModals = function(){
    $('.product-modal-container ').unbind();
    $('.product-modal-container ').remove();
  }  

  // https://github.com/kylefox/jquery-modal
  $('body').on('click', "button[name='spec']", function(e){
    var handle = $(this).attr('data-product-handle');
    var variant = $(this).attr('data-variant-id');
    var url = "/products/"+handle+"?view=specification&variant="+variant;

    $.ajax({
      url: url
    }).done(function( data ) {
      var modal = $(data).appendTo('body').modal();
      modal.on($.modal.AFTER_CLOSE, function(event, modal) {
        window.clearAllModals();
      });      
    });

  });

  $('body').on('click', "img[data-product-modal-window]", function(e){
    const handle = $(this).attr('data-product-handle');
    //const url = "/products/"+handle+"?view=description";
    const baseUrl = window.location.origin;
    var url = "/products/"+handle;
    var defaultTab = $(this).attr('data-default-tab');
    defaultTab ||= 'specification';

    var summaryUrl = new URL(baseUrl+url);
    summaryUrl.searchParams.append('view', defaultTab);

    // const baseUrl = window.location.origin;
    // var summaryUrl = new URL(baseUrl+url);
    // var view = summaryUrl.searchParams.get('view');
    // if(view){
    //   summaryUrl.searchParams.set('view', 'summary');
    // }else{
    //   summaryUrl.searchParams.append('view', 'summary');
    // }    

    $.ajax({
      url: summaryUrl
    }).done(function( data ) {
      var modal = $(data).appendTo('body').modal();
      modal.on($.modal.AFTER_CLOSE, function(event, modal) {
        window.clearAllModals();
      });      
    });

  });

  $('body').on('click', 'button.back-to-modules', function(e){
    if(!$('#modules').hasClass('active')){
      $('#modules').click();
    }
    scrollTo('modules');

    // if(!window.location.href.match(/#modules/)){
    //   var href = window.location.href;
    //   if(href.match(/#.*/)){
    //     var anchor = href.match(/#.*/)[0];
    //     href = href.replace(anchor,'');
    //   }
    //   window.location = href+'#modules';
    // }
    // window.location = window.location.href;
    //https://the-worm-that-turned.myshopify.com/products/urban-hanging-planter?view=modular
  });

  $('body').on('click', 'button.add-to-selection-basket', function(e){
    
    $(this).attr('disabled','true');

    // https://shopify.dev/docs/themes/ajax-api/reference/cart
    var items = $.map( getStore(), function( val, i ) {
      return {quantity: val['quantity'], id: val['variant']}
    });

    var updateCountPrice = function (cart) {
      if ( $('.cart-count').length > 0) {
        $('.cart-count').html(cart.item_count).removeClass('hidden-count');

        if (cart.item_count === 0) {
          $('.cart-count').addClass('hidden-count');
        }
      }
    };

    var cartUpdateCallback = function(cart){
      updateCountPrice(cart);
      //buildCart(cart); // COPY: The same method from theme.js
    }

    var openCart = function(){
      Shopify.getCart(cartUpdateCallback);
      clearStore();
      window.location = '/cart';
    }

    var success = function(data, textStatus){
      $.ajax({
        type: "GET",
        url: '/cart.js',
        success: [openCart],
        dataType: 'json'
      });
    }

    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {items: items},
      success: [success],
      dataType: 'json'
    });
  });

  function updateQuantities(){
    var store = getStore();
    $.each($('#your-selection .modular-item'), function(i,element){
      var productId = $(this).attr('data-product-id');
      var uuid = $(this).find('[data-line-item-uuid]').attr('data-line-item-uuid');
      if(store[uuid]){
        var quantity = store[uuid]['quantity'];      
        $(this).find(".product-quantity-controls input[name='quantity']").val(quantity);
      }      
    });
  }

  //'#temp-5' // modular-item-4652157501500
  window.updateSelection = function(){
    $.each(getStore(), function(key,value){

      // Does the item still exist
      var listItemId = 'modular-item-'+key;
      if($('#'+listItemId).length > 0){
        if($('#'+listItemId).attr('data-variant-id') == value['variant'] ){
          return;
        }
      }

      var selection = value;
      var url = "/products/"+value['handle']+"?view=modular&variant="+value['variant'];
      
      $.ajax({
        url: "/products/"+value['handle']+"?view=modular&variant="+value['variant']+'&line-item='+key
      }).done(function( data ) {
        $('#your-selection').show(); // Show it incase it's been hidden
        $('[data-module-selection-instructions]').hide();
        $('[data-your-selection-totals]').show();
        var element = null;
        if($('#your-selection').find("li[data-modular-item='"+key+"']").length > 0){
          $('#your-selection').find("li[data-modular-item='"+key+"']").html(data);          
        }else{
          $('#your-selection-list').prepend("<li data-modular-item='"+key+"'>"+data+"</li>");
        }
        $('#your-selection').find("li[data-modular-item='"+key+"'] button[name='remove']").attr('data-line-item-uuid', key);
        //$('#your-selection').find("li[data-modular-item='"+key+"']").attr('data-line-item-uuid', key);
        updateQuantities();
      });
    });
  }

  function updateModularCart(variantOptions, index){
    var store = getStore();
    store[index]['variant'] = variantOptions['id'];
    store[index]['price'] = variantOptions['price'];
    saveStore(store);
    update(); 
  }

  //
  $('body').on('quantityChange', '.product-modal-container .product-quantity-controls', function(event, adjustment){
    var quantity = parseInt($("input[name='quantity']").val());
    if((quantity + adjustment) < 1) return;
    $("input[name='quantity']").val( quantity + adjustment);
  });

  $('body').on('click', '.product-modal-container .js--qty-adjuster', function(event){
    event.preventDefault();
    if($(this).hasClass('js--add')){
      $(this).trigger('quantityChange',1);
    }else if($(this).hasClass('js--minus')){
      $(this).trigger('quantityChange',-1);
    }else{
      console.alert('Quantity adjustment has neither classes "js--add" or "js--minus"')
    }
  });

  $('body.template-collection-modular').on('updateModularCart', 'li[data-modular-item]', function(){

    // Is there a variant selection?  
    var productId = $(this).find('[data-product-id]').attr('data-product-id');
    var selectedVariant = null;

    if(productId){
      if($(this).find('[data-variant-select]').length > 0){
        alert('NEED TO IMPLEMENT VARIANT SELECT');
      }else if( $(this).find('[data-index]').length > 0){

        // Loop through each of variants to find any that matches all the options
        var modularItem = $(this);
        var options = {};
        $.each($(modularItem).find('select[data-index]'), function(index, element){
          options[$(element).attr('data-index')] = $(element).val();
        });
        //var selectedVariant = null;
        $.each(window.products[productId], function(i, variant){
          var variantId = null;
          var match = true;
          $.each(options, function(key, value){
            if(variant[key] != value){
              match = false;
            }
          });
          if(match){
            selectedVariant = variant;
            return variant;
          }
        });
      }
      if(selectedVariant == null) return;
      updateModularCart(selectedVariant, $(this).attr('data-modular-item'));
    }
  });

  $('body').on('change', '.modular-item select', function(e){
    $(this).trigger('updateModularCart');
  });

  $('body.template-collection-modular').on('click', '.modular-item .variant-colour-palette li a', function(e){
    e.preventDefault();
    $(this).trigger('colourSelected', $(this).attr('data-colour'));
  });

  $('body.template-collection-modular').on('colourSelected','[data-colour-picker]', function(e, colour){
    $(this).find('a').removeClass('active');
    $(this).find("[data-colour='"+colour+"']").addClass('active');
    $(this).find('select').val(colour);    
    $(this).trigger('updateModularCart');
  });

  $('body.template-collection-modular').on('changeQuantity', '.modular-item', function(e, delta){
    var store = getStore();
    var uuid = $(this).find('[data-line-item-uuid]').attr('data-line-item-uuid');
    if(uuid){
      store[uuid]['quantity'] += delta;
      if(store[uuid]['quantity'] < 0) return;
      saveStore(store);
      update();
    }
  });

  $('body').on('click', '.product-quantity-controls .js--add', function(e){
    $(this).trigger('changeQuantity',1);
  });

  $('body').on('click', '.product-quantity-controls .js--minus', function(e){
    $(this).trigger('changeQuantity',-1);
  });  

  window.addToSelection = function(productId, handle, variantId, price, quantity){
    var options = getStore();    
    if(quantity == undefined){
      quantity = 1;
    }
    //if(options[productId])return;
    //options[uuidv4()] = {quantity: quantity, handle: handle, variant: variantId, product: productId, price: price ,properties: {}};
    options[uuidv4()] = {quantity: quantity, handle: handle, variant: variantId, product: productId, price: price };
    //options.push({quantity: 1, handle: handle, variant: variantId, product: productId, price: price ,properties: {}});
    saveStore(options);    
    //displayButtonAsAdded(productId);
  }

  var version = 'v4';

  function getStore(){
    var collectionId = $('[data-modular-collection]').attr('data-modular-collection');
    var moduleName = 'modular-'+version+'-'+collectionId;
    window.state = { module: moduleName, modal: null};
    var options = {}
    if( Cookies.getJSON(moduleName) ){
      options = Cookies.getJSON(moduleName); 
    }
    return options;
  }

  function clearStore(){
    var collectionId = $('[data-modular-collection]').attr('data-modular-collection');
    var moduleName = 'modular-'+version+'-'+collectionId;
    if( Cookies.getJSON(moduleName) ){
      Cookies.set(moduleName, null);
    }
  }

  function saveStore(store){
    var collectionId = $('[data-modular-collection]').attr('data-modular-collection');
    var moduleName = 'modular-'+version+'-'+collectionId;
    Cookies.set(moduleName, store);
  }

  window.updateTotal = function(){
    var options = getStore();
    var total = _.reduce(options, function(sum, n) {
      if(n['price']==null) return sum;
      return sum + (parseInt(n['price']) * parseInt(n['quantity']));
    }, 0);
    total = total/100.0;
    $('span.total').text('Total: £'+total.toFixed(2).toString());
  }

  // Remove a product from your collection
  $('body').on('click', "button[name='remove']", function(e){
    var options = getStore();
    var uuid = $(this).attr('data-line-item-uuid');
    var productId = $(this).attr('data-product-id');
    if(options[uuid]){
      delete options[uuid]; 
      saveStore(options);
      //var listItemId = 'modular-item-'+productId;
      $('#your-selection-list').find('li[data-modular-item='+uuid+']').fadeOut('fast', function(){ $(this).remove() })
      //enableButton(productId);
    }
    update();
  });  

  $("button[name='add']").on('click', function(e){
    var productId = $(this).attr('data-product-id');
    var productHandle = $(this).attr('data-product-handle');
    var variantId = $(this).attr('data-variant-id');
    var price = parseInt($(this).attr('data-variant-price'));
    addToSelection(productId, productHandle, variantId, price, 1);
    update();
    scrollTo('your-selection');
  });

  /**
  * Add the "Ideas" to the selection
  */
  $("button[name='add-idea']").on('click', function(e){
    var collectionId = $(this).attr('data-collection-id');

    // Collect the variant count
    var selection = {};
    $.each(window.ideas[collectionId], function(key,product){      
      $.each(product.variants, function(index,variantId){
        if (variantId in selection){
          selection[variantId]['quantity'] += 1;
        }else{
          var price = window.variants[variantId]['price'];
          selection[variantId] = {id: variantId, 'quantity': 1, 'productId': product.id, handle: product.handle, price: price};          
        }
      });
    });

    // TODO Try to implement same order
    $.each(selection, function(index, element){
      addToSelection(
        element.productId,
        element.handle, 
        element.id, 
        element.price, 
        element.quantity
      );
    });
    // $.each(window.ideas[collectionId], function(key,value){
    //   //var quantity = 1;      
    //   $.each( value['variants'], function(index, variantId){
    //     //addToSelection(value['id'],value['handle'], variantId, value['price'], quantity);
    //   });
    // });    
    update();
    scrollTo('your-selection');
  });

  function disableButton(productId){
    $(".furniture-and-accessories button[data-product-id='"+productId+"'][name='add']").attr('disabled','true');
  }

  function displayButtonAsAdded(productId){
    //$(".furniture-and-accessories button[data-product-id='"+productId+"'][name='add']").removeAttr('disabled');
    $(".furniture-and-accessories button[data-product-id='"+productId+"'][name='add']").attr('disabled','true');
    $(".furniture-and-accessories button[data-product-id='"+productId+"'][name='add']").find('span').html('Added');
  }

  function enableButton(productId){
    $(".furniture-and-accessories button[data-product-id='"+productId+"'][name='add']").removeAttr('disabled');
    $(".furniture-and-accessories button[data-product-id='"+productId+"'][name='add']").find('span').html('Add to Selection');
  }

  // disabled="true"
  // Disable any products that have already been added
  // TODO Could reverse it - to disable all until we know if it has been added
  $.each(getStore(), function(key,value){
    displayButtonAsAdded(key);
  });

  function getSelectedProducts(){
    var results = [];
    $.each(getStore(), function(key,value){
      results.push(parseInt(key));
    })
    return results;
  }

  // Disable any ideas selection
  function selectedIdeas(){
    var results = [];
    var selectedProducts = getSelectedProducts();
    $.each(window.ideas, function(collectionId, products){
      var missing = null;
      $.each(products, function(index,product){
        if(selectedProducts.includes(product['id']) && missing == null){
          missing = false;
        }else if(!selectedProducts.includes(product['id'])){
          missing = true;
        }
      });
      if(missing == false){
        results.push(collectionId);
      } 
    });
    return results;
  }

  function updateSelectionButtons(){
    // Do all the line items have variants
    if(_.find(getStore(), function(o) { return o.variant == '' }) != undefined){
      $('[data-your-selection-totals] button.add-to-selection-basket').attr('disabled', true);
    }else{
      $('[data-your-selection-totals] button.add-to-selection-basket').removeAttr('disabled');
    }
  }

  function update(){
    updateSelection();

    // TODO Be clever and compare those that need enabled and those that don't (otherwise it is going to flash)
    $(".modular-idea button[name='add-idea']").removeAttr('disabled','true');
    if( $(".modular-idea button[name='add-idea']").attr('data-call-to-action') ){
      $(".modular-idea button[name='add-idea']").each( function(index, element){
        //let value = $(".modular-idea button[name='add-idea']").attr('data-call-to-action');
        let value = $(element).attr('data-call-to-action');
        $(element).find('span').html(value);
      });      
    }else{
      $(".modular-idea button[name='add-idea']").find('span').html('Add pieces to selection');
    }
    
    // Enable any ideas
    // Disable any ideas completly added    
    $.each(selectedIdeas(), function(index, element){
      $(".modular-idea button[data-collection-id='"+element+"'][name='add-idea']").attr('disabled','true');
      $(".modular-idea button[data-collection-id='"+element+"'][name='add-idea']").find('span').html('Added');
    });
    updateTotal();
    updateQuantities();
    updateSelectionButtons();
  }

  update();
});$(document).ready(function(){
    
    $('body').on('changeMainImage', '.product-modal-container', function(e, imageId){
        $(this).find('.product-photo-container [data-image-id]').addClass('hidden');
      $(this).find(`.product-photo-container [data-image-id='${imageId}']`).removeClass('hidden');         
    });      

    $('body').on('click', '.product-modal-container .product-photo-thumbs a', function(e) {
        e.preventDefault();
        $(this).trigger('changeMainImage', $(this).attr('data-image-id') );
    });    
});
$(document).ready(function(){
  if($('[data-dropdown]').length > 0){
    
  }
});
$(document).ready(function(){
  if($('[data-product-question] form').length > 0){
    
    $('form#new_question').on('submit', function(e){
      e.preventDefault();
      var data = $(this).serializeArray();
      data.push({name: 'question[captcha]', value: '8af47f991ac57d7ce9689dc8ae6da760'});
      
      $.ajax({
        url: $(this).attr('action'),
        method: 'post',
        data: data
      }).success(function() {
        $('[data-product-question]').html("<h2>Thank you - we'll respond as quickly as possible</h2>");
      }).error(function(e){
        alert('['+e.statusText+'] Oops, something seems to have went wrong. Please try again. If the issue persists please contact us directly');
      });        
    });

  }
});

const sortByChangeHandler = function(){
  var list = $('[data-collection-products]');
  var listitems = list.children('li').get();
  listitems.sort(function(a, b) {
    var aProductId = parseInt($(a).attr('data-product-id'));
    var bProductId = parseInt($(b).attr('data-product-id'));  
    var indexA = window.collectionsTopRated.indexOf(aProductId);
    var indexB = window.collectionsTopRated.indexOf(bProductId);       
    if((indexA == -1) && (indexB == -1)){
      return -1;
    }
    if(indexA == indexB) return 0;
    if((indexA == -1) || (indexB == -1)){
      return (indexA > indexB) ? -1 : 1;
    }    
    return (indexA > indexB) ? 1 : -1;
  });
  $.each(listitems, function(idx, itm) { list.append(itm); });
  if(document.getElementById('sortBy')){
    document.getElementById('sortBy').value = 'top-rated-items-descending';
  }
}

document.querySelector('body').addEventListener('sortByChange', sortByChangeHandler);

$(document).ready(function(){

  // Check whether on the collections letterbox page
  if($('.sort-by-filters').length > 0){

    let enableTopRatedSort = function(productIds){
      window.collectionsTopRated = productIds;
      var newoption = document.createElement("option");
      newoption.text = "Customer Review";
      newoption.value = 'top-rated-items-descending';
      if(document.getElementById('sortBy')){
        document.getElementById('sortBy').add(newoption);
      }      

      if( Shopify.queryParams.sort_by && Shopify.queryParams.sort_by == 'top-rated-items-descending' ){
        let sortByChangeEvent  = new CustomEvent('sortByChange', {
          detail: {}
        });
        document.querySelector('body').dispatchEvent(sortByChangeEvent);
      }   
    }

    var productIds = [];
    window.collectionSorting.forEach(function(element){
      productIds.push(element['product_id']);
    });
    enableTopRatedSort(productIds);

    // let collectionId = $('#letterboxes-products').attr('data-collection-id');
    // let url = "https://fulfilment.worm.co.uk/api/shopify/v1/collections/"+collectionId+"/average_review_score.json";
    // $.ajax({
    //   url: url,
    //   method: 'GET'
    // }).success(function(e) {
    //   enableTopRatedSort(e);
    // }).error(function(e){
    //   console.error(e.statusText);
    // });
  }
});var customerDOMContentLoadedHandler = () => {
  const url = new URL(location.href);
  const callbackName = url.searchParams.get('form_callback');
  if(callbackName == 'registered'){
    document.querySelectorAll("[data-flash-container]").forEach( (element) => {         
      const message = element.dataset.registeredMessage;
      // message = You have successfully registered please check emails
      element.innerHTML += "<div class='mt-2 bg-indigo-600 p-2 shadow-lg sm:p-3'><div class='flex flex-wrap items-center justify-between'><p class='ml-3 truncate font-medium text-white' style='margin: 0'><span class='md:inline'>"+message+"</span></p></div></div>";
    });      
  }
}

document.addEventListener("DOMContentLoaded", customerDOMContentLoadedHandler);document.addEventListener('DOMContentLoaded', function() {

    // Check if the link has the class 'exclude-icon'
    var links = document.querySelectorAll('a:not(.exclude-external-icon)');
  
    // External link SVG icon
    var externalLinkIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="1rem" height="1rem" style="margin-left: 0.25rem;">' +
      '<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />' +
      '</svg>';

    const externalizeLink = (link) => {
      
      // Check if the link contains text
      var linkText = link.textContent || link.innerText;
      if (linkText.trim() !== '') {
                  
        // Create a container for link text and SVG icon
        var linkContainer = document.createElement('span');
        linkContainer.style.display = 'inline-flex';
        linkContainer.style.alignItems = 'center';

        // Move the link text into the container
        linkContainer.innerHTML = link.innerHTML;

        // Append the SVG icon to the container
        linkContainer.innerHTML += externalLinkIcon;

        // Replace the link content with the container
        link.innerHTML = '';
        link.appendChild(linkContainer);

        // Open the link in a new tab
        link.target = '_blank';        
      };
    };
  
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
  
      // Check if the link is external (not pointing to the same domain)
      if (link.hostname !== window.location.hostname) {
        externalizeLink(link);
      }
    }

  });
  
function loadVideo(element) {
  // Get the video URL from the data-video-src attribute of the clicked element
  var videoSrc = element.getAttribute('data-video-src');
  var videoWidth = element.getAttribute('data-video-width');
  var videoHeight = element.getAttribute('data-video-height');

  var iframe = document.createElement('iframe');
  iframe.setAttribute('src', videoSrc);
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '');
  iframe.setAttribute('webkitallowfullscreen', '');
  iframe.setAttribute('mozallowfullscreen', '');

  // Set iframe width and height if provided
  if (videoWidth) {
    iframe.style.width = videoWidth;
  }

  if (videoHeight) { // Corrected typo and syntax
    iframe.style.height = videoHeight;
  }

  var wrapper = element; // Use the clicked element as the wrapper
  wrapper.innerHTML = ''; // Clear the wrapper's content
  wrapper.appendChild(iframe); // Add the iframe to the wrapper
}

// See /products/fermob-limited-edition-gold-fever-bistro-chair
//
// <div class="cursor-pointer iframe-wrapper" onclick="loadVideo(this)" data-video-src="https://www.youtube.com/embed/DylavAn5zjc?autoplay=1" data-video-width="300px" data-video-height="256px">
// <img height="256" width="300" id="yt-thumb" src="https://cdn.shopify.com/s/files/1/0248/4794/1692/files/bistro_youtube_facade.png?v=1709404265" alt="Video Title">
// </div>
